/**
 * 客户属性选择
 * @author liuys
 */
import api from '@/services/api'
import {METHOD, request} from '@/utils/request'

export const dataApi = {
  async getAttributesList() {
    return request(api.attributes.ATTRIBUTESLIST + '/getCustNatureList', METHOD.GET);
  },

}


export default {dataApi}
